<script lang="ts">
  export let block: boolean | undefined = undefined
  export let flat: boolean | undefined = undefined
</script>

<div class="card" class:block class:flat>
  {#if $$slots.image}
    <div class="image"><slot name="image" /></div>
  {/if}

  {#if $$slots.title}
    <h3><slot name="title" /></h3>
  {/if}

  <div><slot /></div>
</div>

<style lang="scss">
  .card {
    position: relative;
    box-sizing: border-box;
    display: grid;
    overflow: hidden;
    grid-template-rows: auto;
    grid-template-columns: minmax(0, 1fr);
    gap: 0.5em;
    border-radius: 16px;
    background-color: var(--card-background-color, var(--color-surface));
    height: max-content;
    padding: 1em;
    box-shadow:
      0 7px 8px -4px rgba(0, 0, 0, var(--box-shadow-opacity-1, 0.2)),
      0 12px 17px 2px rgba(0, 0, 0, var(--box-shadow-opacity-2, 0.14)),
      0 5px 22px 4px rgba(0, 0, 0, var(--box-shadow-opacity-3, 0.12));

    &.flat {
      box-shadow: none;
      border: 1px solid var(--color-on-surface);
    }

    &:has(> :not(:only-child)) {
      grid-template-rows: max-content auto;
    }

    &.block {
      height: 100%;
    }

    .image {
      margin: -1em -1em 0 -1em;
      border-radius: 4px 4px 0 0;
      overflow: hidden;

      :global(img) {
        max-width: 100%;
      }
    }

    :global(.image:has(*[slot='image']:empty)) {
      display: none;
    }

    h3 {
      margin: 0;
      height: max-content;
    }
  }
</style>
